export default "__VITE_ASSET__0d67cb57__"